import React, { useContext, useEffect, useRef, useState } from "react";
import { Grid, Pagination, Modal } from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import Bread from "../../common/Bread";
import { LangContext } from "../../context/LangContext";
import Loader from "../../common/Loader";
import { getImageAlt } from "../../utils/imageAlt";

import "./csrItems.css";

const CSRItems = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const items = useRef([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  // Modal state
  const [open, setOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewTitle, setPreviewTitle] = useState("");

  useEffect(() => {
    fetchData();
  }, [slug, page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `https://admin.icfcbank.com/api/csr/all/${slug}?page=${page}`,
      );
      setData(res.data.items);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // Language handling
  items.current = nep ? data?.np || [] : data?.en || [];

  // 🔁 Redirect if empty result
  useEffect(() => {
    if (!loading && data && items.current.length === 0) {
      navigate("/csr", { replace: true });
    }
  }, [loading, data, navigate]);

  if (loading) return <Loader />;
  if (error) return <div className="error">Something went wrong.</div>;

  const breadcrumList = {
    image: "",
    link: "/csr",
    title: data?.en?.[0]?.csr_type_name || "",
    l1: nep ? "होम" : "Home",
    l2: nep ? "कर्पोरेट सामाजिक उत्तरदायित्व" : "CSR",
    l3: data?.en?.[0]?.csr_type_name || "",
  };

  // ✅ Gallery logic (single image only)
  const shouldOpenGallery = (item) => {
    return item?.DocPath && (!item?.images || item.images.length == 0);
  };

  const openImage = (image, title) => {
    setPreviewImage(image);
    setPreviewTitle(title);
    setOpen(true);
  };

  const closeImage = () => {
    setOpen(false);
    setPreviewImage(null);
    setPreviewTitle("");
  };

  return (
    <>
      <Bread data={breadcrumList}>
        <Grid container spacing={3}>
          {items.current.map((item, index) => {
            const galleryOnly = shouldOpenGallery(item);

            return (
              <Grid item xs={12} sm={4} md={4} key={index}>
                <div
                  className="box-item-news"
                  onClick={() =>
                    galleryOnly && openImage(item.DocPath, item.Title)
                  }
                  style={{ cursor: galleryOnly ? "pointer" : "default" }}
                >
                  {/* IMAGE */}
                  <div className="img-news">
                      {galleryOnly ? (
                      <img src={item.DocPath} alt={getImageAlt(item, item.Title)} />
                    ) : (
                      <Link to={`/csr/lists/items/details/${item.slug}`}>
                        <img src={item.DocPath} alt={getImageAlt(item, item.Title)} />
                      </Link>
                    )}
                  </div>

                  {/* CONTENT */}
                  <div className="content-news hight-small">
                    <h1>
                      {galleryOnly ? (
                        <span>{item.Title?.substring(0, 100)}</span>
                      ) : (
                        <Link to={`/csr/lists/items/details/${item.slug}`}>
                          {item.Title?.substring(0, 100)}
                        </Link>
                      )}
                    </h1>
                  </div>
                </div>
              </Grid>
            );
          })}
        </Grid>

        {/* PAGINATION */}
        {data?.total > data?.per_page && (
          <Grid container>
            <Grid item xs={12}>
              <Pagination
                className="paginationContainer"
                count={Math.ceil(data.total / data.per_page)}
                color="primary"
                size="large"
                page={page}
                onChange={(e, value) => setPage(value)}
                sx={{ mt: 3 }}
              />
            </Grid>
          </Grid>
        )}
      </Bread>

      {/* ✅ MODAL */}
      <Modal open={open} onClose={closeImage}>
        <div className="singleImageModal">
          <img src={previewImage} alt="Image preview" />
          <h2 className="modalTitle">{previewTitle?.substring(0, 100)}</h2>
        </div>
      </Modal>
    </>
  );
};

export default CSRItems;
